// imports
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { ROUTES } from '../constants';
import GameLayout from '../layouts/game';
import TabView from '../molecules/tabView';
import ItemList from '../molecules/list/item';
import { BackpackItem } from '../common/types';
import ItemDetailView from '../molecules/tabView/sidebar/itemDetailView';
import { selectConfig, selectUIMap } from '../repositories/store/slices';

// exports
export default function BackPack(): JSX.Element {
  // hooks configuration
  const navigate = useNavigate();
  const { state } = useLocation();
  const { world } = useSelector(selectConfig);
  const [item, setItem] = useState<BackpackItem | undefined>(undefined);
  const { currRegion: { id: currRegionId } } = useSelector(selectUIMap);
  // private methods
  const itemClickedCB = (selectedItem?: BackpackItem): void => { setItem(selectedItem); };
  const getBackBtnText = (): string => {
    if (state?.prevPage && state?.prevPage !== ROUTES.GAME) {
      const title = state.prevPage.split('/')[1];
      return title.charAt(0).toUpperCase() + title.slice(1);
    }
    return currRegionId ? world.regions[currRegionId].name : '';
  };
  const backBtnClickHandler = (): void => navigate(state?.prevPage || ROUTES.GAME, { state: { pinId: state?.pinId, quest: state?.quest } });
  const itemDetailView = <ItemDetailView item={item} />;
  // render
  return (
    <GameLayout backButtonText={getBackBtnText()} backBtnClickedCB={backBtnClickHandler}>
      <TabView sidebar={itemDetailView}>
        <ItemList
          selectedItem={item}
          defaultSelected={state?.id}
          itemClickedCB={itemClickedCB}
          filterChangedCB={(backpackItem?: BackpackItem) => { itemClickedCB(backpackItem); }}
        />
      </TabView>
    </GameLayout>
  );
}
